
import { defineComponent } from 'vue';
import PalaLink from '@/ui/components/bases/PalaLink.vue';
import { cefRequest, requestGetter } from "../../utils/cef";

export default defineComponent({
  name: 'LoginPage',
  components: { PalaLink },
  data() {
    return {
      inLogin: false,
      link: '',
      loginTimeout: 0 as any,
    };
  },
  mounted() {
    requestGetter("GET_LOGIN_LINK", {}, (data) => {
      if (data.status === 200 && data.payload && data.payload.link) {
        this.link = data.payload.link;
      }
    });

    // The native login window signals when the whole flow ends (failure or cancel); on success it
    // navigates away and unmounts this page, so the spinner never gets stuck.
    (window as any).loginFinished = () => {
      this.stopLoading();
    };
  },
  beforeUnmount() {
    (window as any).loginFinished = undefined;
    if (this.loginTimeout) {
      clearTimeout(this.loginTimeout);
    }
  },
  methods: {
    stopLoading() {
      this.inLogin = false;
      if (this.loginTimeout) {
        clearTimeout(this.loginTimeout);
        this.loginTimeout = 0;
      }
    },
    async login() {
      if (!this.link || this.inLogin) {
        return;
      }

      // Keep the button in its loading state for the whole login, not just while the window opens.
      this.inLogin = true;
      // Safety net so an older launcher (that does not emit loginFinished) never leaves it stuck.
      this.loginTimeout = setTimeout(() => this.stopLoading(), 180000);
      try {
        const response = await cefRequest("ACTION", "POPUP", {
          title: "Connexion",
          url: this.link,
          width: 536,
          height: 693,
        });
        if (!response || response.status !== 200) {
          this.stopLoading();
        }
      } catch (e) {
        // The login window failed to open, let the user retry.
        this.stopLoading();
      }
    },
  },
});
